'use client'
import React, { useState } from 'react'
import VideoModal from '@/components/videoModel';
import Image from 'next/image';

import DefenseScholarshipThumbnail from "@/assets/image/Defense-Scholarship.webp";
import ScholarshipsThumbnail from "@/assets/image/MSU-Scholarships-2026.webp";

const StudentVideo = () => {
    const [modal, setModal] = useState({ open: false, url: "" });
    const hosteData = [
        {
            thumbImg: ScholarshipsThumbnail,
            url: "https://www.youtube.com/embed/IlDNSOMTdXI?si=IIJqBzGASvR8kCzq",
            tilte: "Medhavi Skills University Scholarships 2026"
        },
        {
            thumbImg: DefenseScholarshipThumbnail,
            url: "https://www.youtube.com/embed/Cwgp6Y-2Q4c?si=CVqwKAPI6YvcZBDZ",
            tilte: "Scholarships for Defence & Security Forces"
        },
    ]
    return (
        <div className='w-full mt-4'>
            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={() => setModal({ open: false, url: "" })}
            />
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                {hosteData.map((ele, index) => (
                    <div key={index} className="w-full">

                        <div className="relative overflow-hidden shadow-md">
                            <Image
                                src={ele.thumbImg}
                                alt="Hoste-Thumbnail"
                                className="w-full h-full object-cover"
                            />

                            <div className="absolute inset-0 bg-black/50 z-10"></div>

                            <div className="absolute inset-0 flex items-center justify-center z-20">
                                <button
                                    onClick={() =>
                                        setModal({
                                            open: true,
                                            url: ele.url,
                                        })
                                    }
                                    className="flex justify-center items-center cursor-pointer w-12 h-12 md:w-14 md:h-14 rounded-full
            bg-white text-[#081E2D] p-3 shadow-lg hover:scale-105 transition"
                                >
                                    <Image
                                        src="/play.svg"
                                        alt="Play"
                                        width={18}
                                        height={22}
                                        className="ml-1.5"
                                    />
                                </button>
                            </div>
                        </div>

                        <h2 className="my-3 md:my-8 text-xl md:text-2xl lg:text-3xl font-semibold text-center">
                            {ele.tilte}
                        </h2>

                    </div>
                ))}
            </div>

        </div>
    )
}

export default StudentVideo